exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "task-monitor {\n  display: block;\n}\n.not-started {\n  color: var(--color-concrete);\n}\n", ""]);

